import React from "react";
import ReactDOM from "react-dom";
//Import the component
import App from "./App";
import "./index.css" //Import Style
//Import Auth0
import {Auth0Provider} from "@auth0/auth0-react";


const domainVal = process.env.REACT_APP_AUTH0_DOMAIN;
const clientIdVal = process.env.REACT_APP_CLIENT_ID;
const redirectUriVal = process.env.REACT_APP_REDIRECT_URI;

ReactDOM.render
(

    <Auth0Provider
        domain={domainVal}
        clientId={clientIdVal}
        redirectUri={redirectUriVal}
    >
        <App/> 
    </Auth0Provider>,
document.getElementById("root")
);